import { render, staticRenderFns } from "./PatientProfile.vue?vue&type=template&id=57ffd3a6&scoped=true"
import script from "./PatientProfile.vue?vue&type=script&lang=js"
export * from "./PatientProfile.vue?vue&type=script&lang=js"
import style0 from "./PatientProfile.vue?vue&type=style&index=0&id=57ffd3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ffd3a6",
  null
  
)

export default component.exports